import { useCallback, useMemo } from 'react'
import { FinalSellData, SellData } from '@app/store/sell'
import { $alert, toast } from '@/utils'
import { useLocal } from '@/i18n/LocalContext'
import { useStore } from '@/store'

export function useSell() {
  const { $t } = useLocal()
  const { state, dispatch } = useStore()
  const count = state.sellCount
  const setCount = useCallback((value: number) => {
    dispatch({
      type: 'setState',
      data: { sellCount: value },
    })
  }, [])

  const sell = useCallback(
    (source: FinalSellData['source'], data: SellData) => {
      if (data.tree <= 0) {
        toast($t('玩家没有圣诞树，无法进行出售'), true)
        return
      }

      const finalSellData: FinalSellData = {
        source,
        data: data.list[0],
        tree: data.tree,
      }

      if (!finalSellData.data || finalSellData.data.overage <= 0) {
        toast($t('当前玩家集市已售罄'), true)
        return
      }

      setCount(0)

      const actionData: Record<string, unknown> = {
        finalSellModalOpen: true,
        finalSellData,
      }

      if (source === 'market') {
        actionData.sellListModalOpen = false
      } else {
        actionData.sellModalOpen = false
      }

      dispatch({
        type: 'setState',
        data: actionData,
      })
    },
    [setCount]
  )

  return {
    sell,
    count,
    setCount,
  }
}
